var _circle, _circle2, _circle3, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransdekUlevaade2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 140,
    viewBox: "0 0 180 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125.63,
    cy: 106.909,
    r: 2.844,
    transform: "rotate(-160.505 125.63 106.909)",
    fill: "#E4966A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.489,
    cy: 111.397,
    r: 3.16,
    transform: "rotate(-137.3 145.489 111.397)",
    fill: "#009B81"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.112,
    cy: 96.1257,
    r: 2.212,
    transform: "rotate(-137.3 147.112 96.1257)",
    fill: "#E4966A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8086 64.1899C41.7253 60.4808 39.2827 55.3015 39.0182 49.7914C38.7536 44.2814 40.6887 38.8919 44.3979 34.8086C48.107 30.7254 53.2863 28.2828 58.7964 28.0182C64.3064 27.7536 69.6959 29.6888 73.7792 33.3979",
    stroke: "#009B81",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "10 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.209 97H93.5969V91.7544H65.8177V49.7895H102.34V65.4841H107.557V47.1667C107.557 46.4711 107.282 45.804 106.793 45.3121C106.304 44.8203 105.64 44.5439 104.948 44.5439H63.209C62.5172 44.5439 61.8536 44.8203 61.3644 45.3121C60.8752 45.804 60.6003 46.4711 60.6003 47.1667V94.3772C60.6003 95.0728 60.8752 95.7399 61.3644 96.2318C61.8536 96.7236 62.5172 97 63.209 97ZM94.5134 57.658H73.6438V62.9036H94.5134V57.658ZM94.5134 68.1492H73.6438V73.3948H94.5134V68.1492ZM86.6873 78.6404H73.6438V83.886H86.6873V78.6404Z",
    fill: "#828282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1345 69.0798V70.5639H107.849V72.048H99.0632V73.5321H96.1345V75.0162H106.385V76.5003H99.0632V77.9844H96.1345V79.4684H104.921V80.9525H99.0632V82.4366H96.1345V83.9207H103.456V85.4048H99.0632V91.3411C99.0632 92.2316 99.6489 92.8252 100.528 92.8252H101.992C102.285 90.3023 104.481 88.2335 107.117 88.2335C109.753 88.2335 111.949 90.1539 112.242 92.8252H116.635C117.514 92.8252 118.1 92.2316 118.1 91.3411V70.5639C118.1 69.6735 117.514 69.0798 116.635 69.0798H96.1345ZM121.028 75.0162C120.15 75.0162 119.564 75.6098 119.564 76.5003V91.3411C119.564 92.0832 120.15 92.8252 121.028 92.8252C121.321 90.3023 123.518 88.2335 126.154 88.2335C128.789 88.2335 130.986 90.1539 131.279 92.8252H132.743C133.622 92.8252 134.207 92.2316 134.207 91.3411V83.9207C134.207 82.585 133.017 80.9525 133.017 80.9525L129.814 76.5003C129.082 75.6098 128.643 75.0162 127.618 75.0162H121.028ZM123.957 77.9844H127.48C127.773 77.9844 128.076 78.2634 128.076 78.2634L131.141 82.5761C131.434 83.0214 131.737 83.4844 131.737 83.7812H123.957V77.9844ZM107.117 90.1361C106.22 90.1392 105.361 90.5017 104.726 91.1444C104.092 91.7872 103.734 92.6581 103.73 93.5673C103.733 94.4767 104.091 95.348 104.726 95.9911C105.36 96.6342 106.22 96.9968 107.117 97C108.014 96.9968 108.874 96.6342 109.509 95.9911C110.143 95.348 110.501 94.4767 110.504 93.5673C110.501 92.6578 110.143 91.7865 109.509 91.1435C108.874 90.5004 108.014 90.1377 107.117 90.1346V90.1361ZM126.154 90.1361C125.256 90.1392 124.397 90.5017 123.762 91.1444C123.128 91.7872 122.77 92.6581 122.767 93.5673C122.77 94.4767 123.127 95.348 123.762 95.9911C124.396 96.6342 125.256 96.9968 126.154 97C127.051 96.9968 127.911 96.6342 128.545 95.9911C129.18 95.348 129.537 94.4767 129.541 93.5673C129.537 92.6578 129.18 91.7865 128.545 91.1435C127.911 90.5004 127.051 90.1377 126.154 90.1346V90.1361Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransdekUlevaade2);
export default __webpack_public_path__ + "static/media/transdek-ulevaade2.9af77801d117dae6ef8040c5776847dd.svg";
export { ForwardRef as ReactComponent };